<template>
  <div
    ref="kt_modal_paises"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_paises"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center">
                <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
                <h3 class="fw-bold m-0 text-gray-800">Países</h3>
              </div>
              <div
                class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalPaises', false)"
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="card-header border-0 pt-5">
                <div class="card-title">
                  <div class="d-flex align-items-center position-relative my-1">
                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                    <input
                      type="text"
                      id="txtPesquisarPaises"
                      v-model="tableData.search"
                      @input="onSearch($event.target.value)"
                      class="form-control form-control-solid w-250px ps-15"
                      placeholder="Pesquisar Países"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Datatable
                  ref="table"
                  :table-header="tableHeader"
                  :table-data="tableData"
                  :table-pagination="tablePagination"
                  :page-sizes="pageSizes"
                  :enable-items-per-page-dropdown="true"
                  :hide-on-single-page="false"
                  empty-table-text="Nenhum país encontrado"
                >
                  <template v-slot:cell-codigo="{ row: pais }">
                    {{ pais.codigo }}
                  </template>
                  <template v-slot:cell-descricao="{ row: pais }">
                    {{ pais.descricao }}
                  </template>
                  <template v-slot:cell-codbacen="{ row: pais }">
                    {{ pais.codbacen }}
                  </template>
                  <template v-slot:cell-acoes="{ row: pais }">
                    <div>
                      <button
                        data-bs-dismiss="modal"
                        class="btn btn-sm btn-light-primary me-2"
                        @click="selecionarRegistro(pais)"
                      >
                        Selecionar
                      </button>
                    </div>
                  </template>
                </Datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";

export default {
  emits: ["exibirModalPaises", "confirmarPais"],
  components: {
    Datatable,
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(codigo, '" +
          pesquisa +
          "') or contains(descricao, '" +
          pesquisa +
          "') or contains(codbacen, '" +
          pesquisa +
          "') ";
      } else {
        this.tableData.filterOData = "";
      }
    },
    selecionarRegistro(pais) {
      this.$emit("confirmarPais", pais);
      this.$emit("exibirModalPaises", false);
    },
  },
  async mounted() {
    setTimeout(() => {
      this.nextFocus("txtPesquisarPaises");
    }, 800);
  },
  data() {
    return {
      tableHeader: [
        {
          name: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Cod. Bacen",
          key: "codbacen",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "pais/getPaisOData",
        selectOData: "?$select=codigo,descricao,codbacen",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
